import React from 'react'
import { BetterComponent } from '../../../components/better-component/better-component'
import { BetterSelect } from '../../../components/better-select/better-select'
import { IFilterBuilderProps } from '../interfaces/filter-builder'
import { getClassNames } from '../../../_utils/classnames'
import { AppService } from '../../../services'
import { Container } from 'typescript-ioc/es5'
import { PromptSearchBar } from '../../../components/prompt-search-bar/prompt-search-bar'
import { ReportFilterOperator } from '../enums/report-filter-operator'
import './style/prompt-id.filter-builder.scss'
import clone from 'clone'

export class PromptIdFilterBuilder extends BetterComponent<IFilterBuilderProps, any> {
    protected appService: AppService

    constructor(props: IFilterBuilderProps) {
        super(props)

        this.appService = Container.get(AppService)
    }

    public render(): React.ReactNode {
        return (
            <>
                <div className={getClassNames('filter', 'pid-filter')}>
                    <div className={getClassNames('filter-wrapper')}>
                        <div className={getClassNames('filter-display')}>
                            <span className="filter-op">{this.currentOperatorDisplay}</span>
                        </div>
                        <div className={getClassNames('filter-editor')}>
                            <div className="filter-op">
                                <BetterSelect
                                    size="small"
                                    disableSearch={true}
                                    dropdownClassName="filter-op-dropdown"
                                    options={[
                                        { value: ReportFilterOperator.IN, label: 'is' },
                                        { value: ReportFilterOperator.NOT_IN, label: 'is not' },
                                    ]}
                                    defaultValue={[ReportFilterOperator.IN]}
                                    value={this.currentValue.operator}
                                    onChange={(operator: ReportFilterOperator) => {
                                        this.handleChange({ operator })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="filter-val">
                            <PromptSearchBar
                                className="prompt-search"
                                mode={this.props.mode === 'display' ? 'display' : 'search'}
                                value={this.currentValueStr}
                                placeholder="Search ID or Name"
                                onChange={this.handlePromptChange}
                                getDropdownContainer={this.appService.getAppContainer}
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    }

    protected get currentValue(): any {
        const propsValue: any = this.props.value || {}
        return clone({
            field: 'PROMPT_ID',
            operator: propsValue.operator || ReportFilterOperator.IN,
            value: propsValue.value,
        })
    }

    protected get currentOperatorDisplay(): any {
        return this.currentValue.operator === ReportFilterOperator.IN ? 'is' : 'is not'
    }

    protected get currentValueStr(): any {
        const value = this.currentValue.value || undefined
        return Array.isArray(value) ? value.join(',') : value
    }

    protected handlePromptChange = (promptId: number) => {
        this.handleChange({ value: !promptId ? undefined : [promptId] })
    }

    protected handleChange(config: any): any {
        if (!!config) {
            this.props.onChange({
                ...this.props.value,
                ...config,
                field: 'PROMPT_ID',
            })
        } else {
            this.props.onChange()
        }
    }
}
